module.exports = __webpack_public_path__ + "static/media/overscan-example.525e4349.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./public/overscan-example.mp4
 ** module id = 467
 ** module chunks = 0
 **/